import React from "react"

import { ButtonPrimaryBlue } from "../Buttons"

import { Section, Container, Heading, Body } from "./404Elements"

const index = () => {
  return (
    <Section>
      <Container>
        <Heading>The End.</Heading>
        <Body>Just kidding, let’s try that again.</Body>
        <ButtonPrimaryBlue text={"HOME"} link={"/"} textMargin={"4rem"} />
      </Container>
    </Section>
  )
}

export default index
